export class Usuario {

    constructor(
        public displayName?: string,
        public mail?: string,
        public foto?: string,
        public userPrincipalName?:string
    ) { }

    get imagen() {
        if(this.foto){
            return this.foto;
        }
        return './assets/images/users/no-imagen.jpg';
    }
}
